// this file is automatically generated by git-version script
export const version = {
  name: 'amg-provider-client',
  version: '1.65.0',
  commit: '9b31a7bbe272b9d93c22d3cd3ab11c358b57e34b',
  branch: 'feature/APA-4427',
  dateGenerated: '2026-06-16T11:57:44.522Z',
};